import React, { useState, useEffect, useCallback } from 'react';
import { string } from 'prop-types';
import { params, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import { LinkSets } from './LinkSets';
import './seo-links.scss';

export const SeoLinks = ({ path }) => {

  let linkSets = [];
  const defaultRender = () => {
    return null;
  };

  if (!path) return defaultRender();

  const options = {
    ssr: true,
    variables: { path }
  };

  const { loading, error, data } = useDataModel('seoLinks', options);

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('seo-links.ready'); }, []);

  const [showMore, setOverlay] = useState(false);
  const toggleOverlay = useCallback(() => {
    setOverlay((seeMore) => !seeMore);
  }, []);

  if (loading || (error && !data) || !data?.seoLinks) {
    return null;
  }

  try {
    let seoLinks = JSON.parse(data.seoLinks);
    linkSets = seoLinks?.sets || [];
  } catch (err) {
    return defaultRender();
  }

  if (linkSets.length === 0) {
    return defaultRender();
  }

  return (
    <div className="col__12-12">
      <div className={
        showMore ? 'seo-links' : 'seo-links collapsed'
      }
      >
        <h2 className="seo-links-heading">Explore More on homedepot.com</h2>
        <LinkSets sets={linkSets} />
        <div className="seo-links__more__overlay">
          <img
            src="https://assets.homedepot-static.com/images/v1/caret-orange.svg"
            alt="more link"
            className="seo-links__more__icon"
          />
          <button className="seo-links__more__toggle" href="#" onClick={toggleOverlay} type="button">
            <span>{showMore ? 'See Less' : 'See More'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

SeoLinks.displayName = 'SeoLinks';

SeoLinks.dataModel = {
  seoLinks: params({ path: stringType() }).string()
};

SeoLinks.propTypes = {
  path: string.isRequired
};
